<template>
<div>
  <a-card :bordered="false">
    <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
      <div></div>
      <a-button type="primary" @click="()=>{this.$router.push(`/goods-category`)}">
        返回
      </a-button>
    </div>
    <a-table
      :scroll="{ y: 'calc(100vh - 200px)'}"
      row-key="id"
      :data-source="table.data"
      :columns="table.columns"
      :pagination="table.pagination"
      :loading="table.loading"
      @change="handleTableChange"
      style="width: 100%">
        <span slot="img" slot-scope="text, record">
           <a-avatar :size="50" shape="square" :src="record.coverPath"/>
        </span>
    </a-table>

  </a-card>
</div>

</template>

<script>
import {
  _queryGoods
} from '@/api/goodsApi.js';

async function getGoodsListByCategoryId() {
  this.loading = true;
  const { order } = this.table.sort;
  const result = await _queryGoods({
    categoryId: this.categoryId,
    page: this.table.pagination.current,
    size: this.table.pagination.pageSize,
    sort: this.table.sort.prop,
    direction: order === 'ascend' ? 'ASC' : 'DESC',
  });
  if (result) {
    this.table.data = result.content;
  }
  this.loading = false;
  this.table.pagination.total = result.totalElements;
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  if (sorter.field) {
    this.table.sort = {
      prop: sorter.field,
      order: sorter.order,
    };
  }

  this.getGoodsListByCategoryId();
}
const columns = [
  {
    title: '图片',
    scopedSlots: { customRender: 'img' },
  },
  {
    title: '商品名',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '编号',
    dataIndex: 'code',
  }
];
export default {
  name: 'GoodsCategoryIdDetail',
  props: {

    categoryName: String,

  },
  data() {
    return {
      categoryId: '',
      table: {
        data: [],
        columns,
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        loading: false,
        sort: {
          prop: 'sort',
          order: 'DESC',
        },
      }
    };
  },
  methods: {
    getGoodsListByCategoryId,
    handleTableChange,
  },
  created() {
    this.categoryId = this.$route.params.categoryId;
    if (this.categoryId) {
      this.getGoodsListByCategoryId();
    }
  }
};
</script>

<style scoped lang="scss">

</style>
